import { useNavigate } from 'react-router-dom';

export const useCheckEmail = (
  data: {
    email: string;
    captcha_id: string;
    captcha_answer: string;
  },
  validateEmail: (data: {
    email: string;
    captcha_id: string;
    captcha_answer: string;
  }) => void,
) => {
  const navigate = useNavigate();

  const handleButtonClick = async () => {
    validateEmail({ email: '', captcha_answer: '', captcha_id: '' });
  };

  const handleReturnToLogin = () => {
    navigate('/auth/login', { replace: true });
  };

  return {
    handleButtonClick,
    handleReturnToLogin,
  };
};
